import { BookOpen } from 'lucide-react'
import { useEffect } from 'react'
import { useLocation } from '#router'
import Editor from './editor'
import { validProblemSlugs } from './editor/problem-context'
import LoadingFallback from './loading-fallback'
import NotFound from './not-found'

export default function ValidatedEditor() {
  const location = useLocation()
  const problemSlug = location.searchParams.get('problem')

  // No problem slug at all — redirect to problems list.
  // This handles cases where the browser drops the query string
  // (e.g. Safari bfcache, gesture-back on iPad).
  useEffect(() => {
    if (!problemSlug) {
      location.navigate('/problems', { replace: true })
    }
  }, [problemSlug, location])

  if (!problemSlug) return <LoadingFallback />

  if (!validProblemSlugs.has(problemSlug)) {
    return (
      <NotFound
        message="This problem doesn't exist or hasn't been added yet."
        buttonLabel="Browse Problems"
        buttonHref="/problems"
        buttonIcon={BookOpen}
      />
    )
  }

  return <Editor />
}
